import { Petition } from "../../../../src/components/ctas/petition";
import * as React from 'react';
export default {
  Petition,
  React
};